import "../parts-list/PartsList.css";
import { useEffect, useState } from "react";
import { FaRegCopy } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";

export const PartsListFixation = ({
  calculatorDataResult,
  systemType,
  language,
}) => {
  const [formDataResult, setFormDataResult] = useState(null);
  const [copyIcon, setCopyIcon] = useState(<FaRegCopy />);
  const [copyText, setCopyText] = useState("Quantity");

  useEffect(() => {
    setFormDataResult(calculatorDataResult);
  }, [calculatorDataResult]);

  // Limpar o estado local quando o systemType mudar
  useEffect(() => {
    setFormDataResult(null);
  }, [systemType]);

  // Objeto de tradução para os textos em diferentes idiomas
  const languageTexts = {
    "pt-br": {
      title: "Relação de Componentes da Fixação",
      copyQuantity: "Quantidade",
      copied: "Copiado",
      components: {
        screw: "Parafuso Bicromatizado 8mm",
        nylonPlug: "Bucha de Nylon 8mm",
      },
    },
    en: {
      title: "Fixation Components List",
      copyQuantity: "Quantity",
      copied: "Copied",
      components: {
        screw: "Bichromated Screw 8mm",
        nylonPlug: "Nylon Plug 8mm",
      },
    },
    es: {
      title: "Lista de Componentes de Fijación",
      copyQuantity: "Cantidad",
      copied: "Copiado",
      components: {
        screw: "Tornillo Bicromatado 8mm",
        nylonPlug: "Taco de Nylon 8mm",
      },
    },
  };

  // Obtém os textos correspondentes à linguagem selecionada
  const texts = languageTexts[language] || languageTexts["en"]; // Se a linguagem não for encontrada, usa o inglês como padrão

  const copyToClipboard = () => {
    const textarea = document.createElement("textarea");
    const quantities = document.querySelectorAll(".quantidade-column-fixation");

    const quantitiesText = Array.from(quantities)
      .map((quantity) => quantity.textContent)
      .join("\n");

    textarea.value = quantitiesText;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    // Altera o ícone para FaCheck por 2 segundos
    setCopyIcon(<FaCheck />);
    setCopyText(texts.copied);
    setTimeout(() => {
      setCopyIcon(<FaRegCopy />);
      setCopyText(texts.copyQuantity);
    }, 500);

    // Altera a classe 'clicked' para a animação
    const thElement = document.querySelector(".parts-list th");
    thElement.classList.add("clicked");
    setTimeout(() => {
      thElement.classList.remove("clicked");
    }, 500); // Ajusta a duração da animação aqui
  };

  const { totalParafusos, totalBuchas } = formDataResult ? formDataResult : {};

  return (
    <div className="parts-list container parts-list-fixation">
      <h2>{texts.title}</h2>
      <table>
        <thead>
          <tr>
            <th>Código</th>
            <th>Item</th>
            <th onClick={copyToClipboard}>
              {texts.copyQuantity} {copyIcon}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>303.001.002</td>
            <td>{texts.components.screw}</td>
            <td className="quantidade-column-fixation" id="totalParafusos">
              {totalParafusos}
            </td>
          </tr>
          <tr>
            <td>303.001.005</td>
            <td>{texts.components.nylonPlug}</td>
            <td className="quantidade-column-fixation" id="totalBuchas">
              {totalBuchas}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
